/**
 * @generated SignedSource<<6b34a80602387913f2efaef1bf23f13d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type Currency = "BRL" | "USD" | "%future added value";
export type DaySheetlyPageUpdateMutation$variables = {
  billingStatus?: BillingStatus | null | undefined;
  currency?: Currency | null | undefined;
  date?: string | null | undefined;
  description?: string | null | undefined;
  duration?: string | null | undefined;
  endDate?: string | null | undefined;
  hourlyRate?: number | null | undefined;
  id: string;
  memberIds?: ReadonlyArray<string> | null | undefined;
  projectId?: string | null | undefined;
  title?: string | null | undefined;
};
export type DaySheetlyPageUpdateMutation$data = {
  readonly updateTask: {
    readonly billingStatus: BillingStatus;
    readonly currency: Currency;
    readonly date: string;
    readonly description: string | null | undefined;
    readonly durationMinutes: number;
    readonly endDate: string | null | undefined;
    readonly hourlyRate: number;
    readonly id: string;
    readonly members: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly project: {
      readonly color: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly title: string;
  };
};
export type DaySheetlyPageUpdateMutation = {
  response: DaySheetlyPageUpdateMutation$data;
  variables: DaySheetlyPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hourlyRate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberIds"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "billingStatus",
        "variableName": "billingStatus"
      },
      {
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency"
      },
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "duration"
      },
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "hourlyRate",
        "variableName": "hourlyRate"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "memberIds",
        "variableName": "memberIds"
      },
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "updateTask",
    "plural": false,
    "selections": [
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DaySheetlyPageUpdateMutation",
    "selections": (v13/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "DaySheetlyPageUpdateMutation",
    "selections": (v13/*: any*/)
  },
  "params": {
    "cacheID": "58ab2816ce03340356e47c603d43b83d",
    "id": null,
    "metadata": {},
    "name": "DaySheetlyPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation DaySheetlyPageUpdateMutation(\n  $id: ID!\n  $title: String\n  $description: String\n  $date: String\n  $endDate: String\n  $duration: String\n  $projectId: ID\n  $hourlyRate: Float\n  $currency: Currency\n  $billingStatus: BillingStatus\n  $memberIds: [ID!]\n) {\n  updateTask(id: $id, title: $title, description: $description, date: $date, endDate: $endDate, duration: $duration, projectId: $projectId, hourlyRate: $hourlyRate, currency: $currency, billingStatus: $billingStatus, memberIds: $memberIds) {\n    id\n    title\n    description\n    date\n    endDate\n    durationMinutes\n    hourlyRate\n    currency\n    billingStatus\n    project {\n      id\n      name\n      color\n    }\n    members {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65e83badc294c381010b75c947acb224";

export default node;
